module.exports = __webpack_public_path__ + "img/calendar-1_fill.96ed8c3c.svg";